import React, { Component, Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Container,
  Button, Stack
} from "react-bootstrap";
import { UserView } from "../userView/userView";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../login/loginApi";
import { setPageName } from "../login/loginSlice";

export function MainControl(props) {

  const log = useSelector((state) => state.login)
  const dispatch = useDispatch()

  let navigate = useNavigate();
  useEffect(() => {
    if (!log.token) {
      return navigate("/login");
    } else {
      dispatch(setPageName("Профиль"))
    }
  })
  return (<Fragment>
    <div className="col-xl-5 col-lg-6 mx-auto">
      <UserView />

    </div>

  </Fragment>)

}

export default MainControl;
